import { vector3, Vector3 } from '@fulcrum/lib';
import { TcModelAlignment } from '@data-access/connect/tc-tcps';

export type Axis = 'x' | 'y' | 'z';

export interface VectorDraft {
  x: string;
  y: string;
  z: string;
}

export interface PositionDraft {
  position: VectorDraft;
  rotation: VectorDraft;
  move: VectorDraft & { distance: string };
  scale: string;
}

export interface PositionFormState {
  alignment: TcModelAlignment;
  initialPosition: Vector3;
  move: Vector3;
  rotation: Vector3;
  scalePercent: number;
  draft: PositionDraft;
}

export const PERCENT_FACTOR = 100;

export const DEFAULT_IDENTITY_MODEL_ALIGNMENT: TcModelAlignment = {
  fileId: '',
  versionId: '',
  locationX: 0,
  locationY: 0,
  locationZ: 0,
  axisX: 0,
  axisY: 0,
  axisZ: 1,
  refDirectionX: 1,
  refDirectionY: 0,
  refDirectionZ: 0,
  scale: 1,
};

export const EMPTY_VECTOR_DRAFT: VectorDraft = { x: '0', y: '0', z: '0' };

export const DEFAULT_DRAFT: PositionDraft = {
  position: { ...EMPTY_VECTOR_DRAFT },
  rotation: { ...EMPTY_VECTOR_DRAFT },
  move: { ...EMPTY_VECTOR_DRAFT, distance: '0' },
  scale: PERCENT_FACTOR.toString(),
};

export const DEFAULT_FORM_STATE: PositionFormState = {
  alignment: { ...DEFAULT_IDENTITY_MODEL_ALIGNMENT },
  initialPosition: vector3(0, 0, 0),
  move: vector3(0, 0, 0),
  rotation: vector3(0, 0, 0),
  scalePercent: PERCENT_FACTOR,
  draft: { ...DEFAULT_DRAFT },
};
